// DongLT ADD 2024/10/30 Start
document.addEventListener('DOMContentLoaded', function() {
  var banners = document.querySelectorAll('[id^="Banner-"]');
  
  banners.forEach(function(banner) {
    var link = banner.getAttribute('data-banner-link');

    console.log(link)
    if (link) {
      banner.addEventListener('click', function(event) {
        event.preventDefault(); 
        var linkUrl = new URL(link, window.location.origin);

        console.log(linkUrl.hostname)
        console.log(window.location.hostname)
        if (link.startsWith('/')) {
          window.location.href = link;
        } else if (linkUrl.hostname !== window.location.hostname) {
          window.open(link, '_blank');
        } else {
          window.location.href = link;
        }
      });
    }
  });
});
// DongLT ADD 2024/10/30 End